import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";
import Link from "next/link";

const credStartData = {
    heading: "Get Started with Credlix Today",
    cards: [
      {
        icon: IMAGES.termsheet.easy, 
        title: "Easy Access",
        description: 'Click "Start Your Free Check Now".',
      },
      {
        icon: IMAGES.termsheet.quick,
        title: "Quick Reports",
        description: "Receive your report instantly.",
      },
    ],
    ctaText: "Get Started",
  };

const GetStarted = () => {
  const { heading, cards, ctaText } = credStartData;

  return (
    <section className="pb-[100px]">
        <div className="container xm:px-2 px-3 ">
      <h2 className="text-xxl font-bold mb-4 text-center">{heading}</h2>

      <div className="flex flex-wrap justify-center items-center gap-1 mb-12">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-white border border-[#C4C4C4] rounded-xl shadow-md px-2 py-3 w-full max-w-xs flex flex-col text-left"
          >
            <Image
              src={card.icon}
              alt={card.title}
              width={60}
              height={60}
              className="mb-4"
            />
            <h3 className="text-lg font-semibold mb-1">{card.title}</h3>
            <p className="text-base text-gray-700">{card.description}</p>
          </div>
        ))}
      </div>

      <div className="flex justify-center items-center">
        <Link href="/export-factoring">
          <button className="flex gap-x-1 justify-center py-2 px-20 text-center rounded-md text-white text-base font-medium bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]">
            {ctaText} 
            <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="brand" width="24" height="24" className="fill-current text-white">
            <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg>
          </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
